(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["review-slider"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initSlick() {
    if (typeof jQuery === 'undefined' || typeof jQuery.fn.slick === 'undefined') {
      setTimeout(initSlick, 200);
      return;
    }

    jQuery('.review-slider').not('.slick-initialized').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
     autoplay: true,
      speed: 3000,
      arrows: true,
      dots: false,
      infinite: true,
      pauseOnHover: false,
      adaptiveHeight: true,
      prevArrow: $('.custom-prev'),
      nextArrow: $('.custom-next'),
      responsive: [
        { 
            breakpoint: 992, 
            settings: {
                 slidesToShow: 2 
                }
             },
       { 
            breakpoint: 768, 
            settings: {
                arrows: false,
                dots: true,
                 slidesToShow: 1
                }
             },
      ]
    });
  }

  document.addEventListener('shopify:section:load', initSlick);
  document.addEventListener('DOMContentLoaded', initSlick);
})();

  } catch(e) { console.error(e); }
})();
})();
